import { FC, PropsWithChildren } from 'react';
import CopyButton from '../CopyButton/CopyButton';
import QRViewButton from '../QRViewButton/QRViewButton';

import styles from './CopyInfoField.module.scss';

type CopyInfoFieldProps = {
	label: string;
	copyContent: string;
	displayValue?: string;
	infoMessage?: string;
};

const CopyInfoField: FC<PropsWithChildren<CopyInfoFieldProps>> = ({
	children,
	copyContent,
	displayValue,
	label,
	infoMessage,
}) => {
	return (
		<div className={styles.container}>
			<label className={styles.label}>{label}</label>
			<div className={styles.input}>
				<div className={styles.content} data-cy="copy-content">
					{children}
				</div>
				<div className={styles.actions}>
					<QRViewButton
						className={styles.icon}
						data={copyContent}
						label={label}
						displayValue={displayValue || copyContent}
						infoMessage={infoMessage}
					/>
					<CopyButton className={styles.icon} dataToCopy={copyContent} />
				</div>
			</div>
		</div>
	);
};

export default CopyInfoField;
